import { FooterBrandBlock } from './footer-brand-block/footer-brand-block'
import { FooterCtaStrip } from './footer-cta-strip/footer-cta-strip'
import { FooterNav } from './footer-nav/footer-nav'
import { FooterUtilityRow } from './footer-utility-row/footer-utility-row'
import s from './footer.module.scss'

export const Footer = () => {
  return (
    <footer className={s.footer}>
      <FooterCtaStrip />
      <div className={s.body}>
        <div className={s.bodyInner}>
          <FooterBrandBlock />
          <FooterNav />
        </div>
      </div>
      <FooterUtilityRow />
    </footer>
  )
}
